import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { Link } from 'components';
import { IncludeContent, Section, Image } from 'bricks';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export default function InfoGraphicItem({
  title,
  imageUrl,
  verticalAlign,
  isMobile,
  hasMarkup,
  onClick,
  popupMarkup,
  href,
  isOnPCHref,
}) {
  const TitleTag = hasMarkup ? Link : 'div';
  const ItemTag = href && (isMobile || isOnPCHref) ? 'a' : 'div';
  return hasMarkup && isMobile ?
      <Section className={cx('')} title={title} isOpen={false}>
        <IncludeContent htmlContent={popupMarkup} />
      </Section>
    : <ItemTag
        href={href || ''}
        className={cx('item', isMobile ? 'itemMobile' : null, verticalAlign && 'itemVertical')}
      >
        <div className={cx('imgWrapper', verticalAlign && 'verticalWrap')}>
          <Image src={imageUrl} alt={title} className={cx('img', verticalAlign && 'vertical')} />
        </div>
        <TitleTag className={cx('title')} onClick={onClick}>
          {title}
        </TitleTag>
      </ItemTag>;
}

InfoGraphicItem.propTypes = {
  title: PropTypes.string,
  imageUrl: PropTypes.string,
  popupMarkup: PropTypes.any,
  verticalAlign: PropTypes.bool,
  isMobile: PropTypes.bool,
  hasMarkup: PropTypes.bool,
  onClick: PropTypes.func,
  href: PropTypes.string,
  isOnPCHref: PropTypes.bool,
};
